import { Validator } from "./types";
import { SearchContextType } from "../search-context";
import ValidationErrorMessages from "./error-messages";

const validateAddressSearch: Validator = (data: SearchContextType) => {
  const { fullAddress, firstName, middleNames, lastName, dateOfBirth } = data;

  const hasAddress = !!fullAddress?.trim();
  const hasAnyOtherValue =
    !!firstName?.trim() ||
    !!middleNames?.trim() ||
    !!lastName?.trim() ||
    !!dateOfBirth?.toString().trim();

  const isAddressOnlySearch = hasAddress && !hasAnyOtherValue;

  if (!hasAddress) {
    return { isValid: false, errors: [] };
  }

  return isAddressOnlySearch
    ? { isValid: true, errors: [] }
    : { isValid: false, errors: [ValidationErrorMessages.invalidAddress] };
};

export default validateAddressSearch;
